import React, { useState } from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { SelectParties } from "@/components/feature/deadline_guardian/verification_view/SelectParties";
import { EventCardProps } from "@/views/home/deadline_guardian/types/types";

export const EventCard: React.FC<EventCardProps> = ({ event, handleSelect, isSelected }) => {
  const [date, setDate] = useState<Date | null>(event.date ? new Date(event.date) : null);

  return (
    <tr className="mb-4 rounded-lg bg-white shadow-lg">
      <td className="mt-2 p-4 pt-6 align-top">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" className="w-[250px] justify-start text-left font-normal">
              <CalendarIcon className="mr-2 h-4 w-4" />
              {date ? format(date, "EEE PPP") : <span>Pick a date</span>}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0">
            <Calendar
              mode="single"
              selected={date ?? undefined}
              onSelect={newDate => setDate(newDate || null)}
              initialFocus
              month={date ?? undefined}
            />
          </PopoverContent>
        </Popover>
      </td>
      <td className="flex-grow px-6 py-6">
        <h3 className="font-semibold">{event.title}</h3>
        <p className="pb-3 pt-3 text-xs text-gray-600">{event.details}</p>
        {event.documentLink && (
          <a href={event.documentLink} className="text-xs text-blue-500 hover:text-blue-700">
            {event.documentRef}
          </a>
        )}
      </td>
      <td className="p-4 align-top" style={{ width: "250px" }}>
        <SelectParties selectedChoice={event.party} />
      </td>
      <td className="mr-6 p-4 pt-9 text-right align-top">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={handleSelect}
          className="form-checkbox h-5 w-5 text-blue-600"
        />
      </td>
    </tr>
  );
};
